import { useEffect, useRef } from 'react';
import { IncomingSocketEvents, OutgoingSocketEvents } from '@connect-x-app/shared-domain-models';
import { Socket } from 'socket.io-client';

export const useSocketEvent = <E extends keyof IncomingSocketEvents>(
  socket: Socket<IncomingSocketEvents, OutgoingSocketEvents> | null,
  event: E,
  callback: IncomingSocketEvents[E],
) => {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!socket) {
      return;
    }

    const handler = (...args: Parameters<IncomingSocketEvents[E]>) => {
      const currentCallback = callbackRef.current as (...args: Parameters<IncomingSocketEvents[E]>) => void;
      currentCallback(...args);
    };

    // @ts-expect-error typing mismatch
    socket.on(event, handler);

    return () => {
      // @ts-expect-error typing mismatch
      socket.off(event, handler);
    };
  }, [socket, event]);
};
